import React from 'react';
import { Chip } from '@mui/material';
import { IconByString } from '../../components/IconByString';

interface StatusChipProps {
  status: number | boolean;
  labelActive?: string;
  labelInactive?: string;
}

export const StatusChip = ({
  status,
  labelActive = 'Activo',
  labelInactive = 'Inactivo',
}: StatusChipProps) => {
  // Treat status 1 or true as active
  const isActive = status === 1 || status === true;

  return (
    <Chip
      icon={
        isActive ? (
          <IconByString iconName="Check" sx={{ fontSize: 16 }} />
        ) : (
          <IconByString iconName="Close" sx={{ fontSize: 16 }} />
        )
      }
      label={isActive ? labelActive : labelInactive}
      size="small"
      sx={{
        color: isActive ? '#5DCC0A' : '#FF4C51',
        bgcolor: isActive ? '#E4F6D6' : '#FFE2E3',
        fontWeight: 700,
      }}
    />
  );
};
